(() => {
  const dcLang = (document.documentElement.lang || 'nl').slice(0, 2).toLowerCase();

  const dcTranslations = {
    en: {
      'Utrecht cadeau categorieën': 'Utrecht gift categories',
      'Voor in huis': 'For the home',
      'Utrechtse woondecoratie en blikvangers voor een plek met karakter.': 'Utrecht home décor and eye-catchers for a place with character.',
      'Persoonlijk cadeau': 'Personal gift',
      'Met naam, datum of tekst voor een cadeau dat echt van iemand is.': 'With a name, date or text for a gift that feels truly personal.',
      'Utrecht op tafel': 'Utrecht on the table',
      'Planken, glaswerk en cadeaus voor koken, borrelen en tafelen.': 'Boards, glassware and gifts for cooking, drinks and dining.',
      'Voor bedrijven': 'For businesses',
      'Utrechtse relatiegeschenken en grotere aantallen met persoonlijke aanpak.': 'Utrecht corporate gifts and larger quantities with a personal approach.',
      'Liever gericht laten kiezen?': 'Prefer a more focused choice?',
      'Beantwoord drie korte vragen en bekijk vier suggesties die bij je keuze passen.': 'Answer three short questions and see four suggestions that fit your choices.',
      'Utrecht cadeaukeuzehulp': 'Utrecht gift finder',
      'Cadeaukeuzehulp': 'Gift finder',
      'Voor wie, welk type en welk budget. Daarna tonen we alleen passende cadeaus.': 'Who it is for, gift type and budget. Then we only show matching gifts.',
      'Vind in 3 stappen jouw Utrecht cadeau': 'Find your Utrecht gift in 3 steps',
      'Voor wie, welk type en welk budget. Wij tonen daarna 4 passende suggesties.': 'Who it is for, gift type and budget. We will then show 4 suitable suggestions.',
      'Open keuzehulp': 'Open gift finder',
      'Sluiten': 'Close',
      'Voortgang cadeaukeuzehulp': 'Gift finder progress',
      'Voor wie?': 'For whom?',
      'Type cadeau': 'Gift type',
      'Budget': 'Budget',
      'Eerste keuze': 'First choice',
      'Voor wie zoek je iets?': 'Who are you looking for a gift for?',
      'Voor hem': 'For him',
      'Persoonlijk gekozen': 'Personally chosen',
      'Voor haar': 'For her',
      'Met Utrechtse uitstraling': 'With Utrecht character',
      'Voor samen': 'For both',
      'Voor een gedeeld moment': 'For a shared moment',
      'Zakelijk': 'Business',
      'Een bijzonder relatiegeschenk': 'A distinctive corporate gift',
      'Voor mezelf': 'For myself',
      'Omdat Utrecht bij je past': 'Because Utrecht suits you',
      'Tweede keuze': 'Second choice',
      'Wat voor cadeau zoek je?': 'What kind of gift are you looking for?',
      'Gepersonaliseerd': 'Personalised',
      'Namen, datum of eigen tekst': 'Names, date or your own text',
      'Typisch Utrecht': 'Typically Utrecht',
      'Domtoren en stadsgevoel': 'Dom Tower and city character',
      'Decoratie, tafel en sfeer': 'Décor, table and atmosphere',
      'Sieraad': 'Jewellery',
      'Draagbaar en persoonlijk': 'Wearable and personal',
      'Houten cadeau': 'Wooden gift',
      'Natuurlijk en ambachtelijk': 'Natural and handcrafted',
      'Klein cadeautje': 'Small gift',
      'Compact en betaalbaar': 'Compact and affordable',
      '← Vorige keuze': '← Previous choice',
      'Laatste keuze': 'Final choice',
      'Wat is ongeveer je budget?': 'What is your approximate budget?',
      'Een klein gebaar': 'A small gesture',
      'Mooi middenbudget': 'Mid-range budget',
      'Iets extra bijzonders': 'Something extra special',
      'Een groter cadeau': 'A larger gift',
      'Jouw selectie staat klaar': 'Your selection is ready',
      'Jouw keuzes': 'Your choices',
      'Keuzes aanpassen': 'Change choices',
      'Voor jou geselecteerd': 'Selected for you',
      'Jouw Utrecht selectie': 'Your Utrecht selection',
      'Opnieuw kiezen': 'Choose again',
      'Alle cadeaus →': 'All gifts →',
      'Personaliseerbaar': 'Customisable',
      'Vanaf': 'From',
      'Bekijk cadeau': 'View gift',
      'Bekijk alle Utrecht cadeaus': 'View all Utrecht gifts',
      'Voor deze combinatie zijn er op dit moment geen cadeaus binnen jouw gekozen budget. Pas je type of budget aan, of bekijk alle cadeaus.': 'There are currently no gifts within your chosen budget for this combination. Adjust your gift type or budget, or view all gifts.',
      'Voor dit type is er binnen jouw budget geen exacte match. Daarom tonen we andere Utrecht cadeaus die wel binnen jouw gekozen budget vallen.': 'There is no exact match for this gift type within your budget. We therefore show other Utrecht gifts that do fit your selected budget.'
    },
    de: {
      'Utrecht cadeau categorieën': 'Utrecht-Geschenkkategorien',
      'Voor in huis': 'Für zu Hause',
      'Utrechtse woondecoratie en blikvangers voor een plek met karakter.': 'Utrechter Wohndekoration und Blickfänge für ein Zuhause mit Charakter.',
      'Persoonlijk cadeau': 'Persönliches Geschenk',
      'Met naam, datum of tekst voor een cadeau dat echt van iemand is.': 'Mit Name, Datum oder Text für ein wirklich persönliches Geschenk.',
      'Utrecht op tafel': 'Utrecht auf dem Tisch',
      'Planken, glaswerk en cadeaus voor koken, borrelen en tafelen.': 'Bretter, Gläser und Geschenke zum Kochen, Genießen und Tafeln.',
      'Voor bedrijven': 'Für Unternehmen',
      'Utrechtse relatiegeschenken en grotere aantallen met persoonlijke aanpak.': 'Utrechter Firmengeschenke und größere Stückzahlen mit persönlicher Betreuung.',
      'Liever gericht laten kiezen?': 'Lieber gezielter auswählen?',
      'Beantwoord drie korte vragen en bekijk vier suggesties die bij je keuze passen.': 'Beantworte drei kurze Fragen und sieh dir vier Vorschläge an, die zu deiner Auswahl passen.',
      'Utrecht cadeaukeuzehulp': 'Utrecht-Geschenkefinder',
      'Cadeaukeuzehulp': 'Geschenkefinder',
      'Voor wie, welk type en welk budget. Daarna tonen we alleen passende cadeaus.': 'Für wen, Geschenkart und Budget. Danach zeigen wir nur passende Geschenke.',
      'Vind in 3 stappen jouw Utrecht cadeau': 'Finde dein Utrecht-Geschenk in 3 Schritten',
      'Voor wie, welk type en welk budget. Wij tonen daarna 4 passende suggesties.': 'Für wen, welche Geschenkart und welches Budget. Danach zeigen wir 4 passende Vorschläge.',
      'Open keuzehulp': 'Geschenkefinder öffnen',
      'Sluiten': 'Schließen',
      'Voortgang cadeaukeuzehulp': 'Fortschritt des Geschenkefinders',
      'Voor wie?': 'Für wen?',
      'Type cadeau': 'Geschenkart',
      'Budget': 'Budget',
      'Eerste keuze': 'Erste Auswahl',
      'Voor wie zoek je iets?': 'Für wen suchst du ein Geschenk?',
      'Voor hem': 'Für ihn',
      'Persoonlijk gekozen': 'Persönlich ausgewählt',
      'Voor haar': 'Für sie',
      'Met Utrechtse uitstraling': 'Mit Utrecht-Charakter',
      'Voor samen': 'Für beide',
      'Voor een gedeeld moment': 'Für einen gemeinsamen Moment',
      'Zakelijk': 'Geschäftlich',
      'Een bijzonder relatiegeschenk': 'Ein besonderes Firmengeschenk',
      'Voor mezelf': 'Für mich selbst',
      'Omdat Utrecht bij je past': 'Weil Utrecht zu dir passt',
      'Tweede keuze': 'Zweite Auswahl',
      'Wat voor cadeau zoek je?': 'Welche Art von Geschenk suchst du?',
      'Gepersonaliseerd': 'Personalisiert',
      'Namen, datum of eigen tekst': 'Namen, Datum oder eigener Text',
      'Typisch Utrecht': 'Typisch Utrecht',
      'Domtoren en stadsgevoel': 'Domturm und Stadtgefühl',
      'Decoratie, tafel en sfeer': 'Dekoration, Tisch und Atmosphäre',
      'Sieraad': 'Schmuck',
      'Draagbaar en persoonlijk': 'Tragbar und persönlich',
      'Houten cadeau': 'Holzgeschenk',
      'Natuurlijk en ambachtelijk': 'Natürlich und handwerklich',
      'Klein cadeautje': 'Kleines Geschenk',
      'Compact en betaalbaar': 'Kompakt und erschwinglich',
      '← Vorige keuze': '← Vorherige Auswahl',
      'Laatste keuze': 'Letzte Auswahl',
      'Wat is ongeveer je budget?': 'Wie hoch ist ungefähr dein Budget?',
      'Een klein gebaar': 'Eine kleine Aufmerksamkeit',
      'Mooi middenbudget': 'Mittleres Budget',
      'Iets extra bijzonders': 'Etwas besonders Schönes',
      'Een groter cadeau': 'Ein größeres Geschenk',
      'Jouw selectie staat klaar': 'Deine Auswahl ist fertig',
      'Jouw keuzes': 'Deine Auswahl',
      'Keuzes aanpassen': 'Auswahl ändern',
      'Voor jou geselecteerd': 'Für dich ausgewählt',
      'Jouw Utrecht selectie': 'Deine Utrecht-Auswahl',
      'Opnieuw kiezen': 'Neu auswählen',
      'Alle cadeaus →': 'Alle Geschenke →',
      'Personaliseerbaar': 'Personalisierbar',
      'Vanaf': 'Ab',
      'Bekijk cadeau': 'Geschenk ansehen',
      'Bekijk alle Utrecht cadeaus': 'Alle Utrecht-Geschenke ansehen',
      'Voor deze combinatie zijn er op dit moment geen cadeaus binnen jouw gekozen budget. Pas je type of budget aan, of bekijk alle cadeaus.': 'Für diese Kombination gibt es derzeit keine Geschenke innerhalb deines gewählten Budgets. Ändere die Geschenkart oder das Budget oder sieh dir alle Geschenke an.',
      'Voor dit type is er binnen jouw budget geen exacte match. Daarom tonen we andere Utrecht cadeaus die wel binnen jouw gekozen budget vallen.': 'Für diese Geschenkart gibt es innerhalb deines Budgets keine exakte Übereinstimmung. Deshalb zeigen wir andere Utrecht-Geschenke, die in dein gewähltes Budget passen.'
    }
  };

  const dcDict = dcTranslations[dcLang] || null;
  const dcSkipTags = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEMPLATE']);
  const dcTranslateDynamic = (text) => {
    if (!dcDict || !text) return text;
    const trimmed = text.trim();
    if (dcDict[trimmed]) return text.replace(trimmed, dcDict[trimmed]);

    let match = trimmed.match(/^Stap (\d+) van (\d+)$/);
    if (match) return dcLang === 'de' ? `Schritt ${match[1]} von ${match[2]}` : `Step ${match[1]} of ${match[2]}`;

    match = trimmed.match(/^(\d+) (cadeau|cadeaus) (past|passen) bij jouw gekozen type en budget\.$/);
    if (match) {
      const count = match[1];
      if (dcLang === 'de') {
        return count === '1'
          ? '1 Geschenk passt zu deiner gewählten Geschenkart und deinem Budget.'
          : `${count} Geschenke passen zu deiner gewählten Geschenkart und deinem Budget.`;
      }
      return count === '1'
        ? '1 gift matches your selected gift type and budget.'
        : `${count} gifts match your selected gift type and budget.`;
    }

    match = trimmed.match(/^(\d+) cadeaus binnen jouw budget die passen bij jouw gekozen type\. Je keuze voor wie het cadeau is, gebruiken we als lichte voorkeur in de volgorde\.$/);
    if (match) {
      return dcLang === 'de'
        ? `${match[1]} Geschenke innerhalb deines Budgets passen zu deiner gewählten Geschenkart. Für wen das Geschenk gedacht ist, verwenden wir als leichte Präferenz bei der Reihenfolge.`
        : `${match[1]} gifts within your budget match your selected gift type. We use who the gift is for as a light preference in the ordering.`;
    }

    match = trimmed.match(/^We vonden (\d+) (cadeau|cadeaus) van het gekozen type binnen jouw budget\. De overige suggesties vallen ook binnen jouw budget\.$/);
    if (match) {
      if (dcLang === 'de') return `Wir haben ${match[1]} ${match[1] === '1' ? 'Geschenk' : 'Geschenke'} der gewählten Art innerhalb deines Budgets gefunden. Die übrigen Vorschläge liegen ebenfalls innerhalb deines Budgets.`;
      return `We found ${match[1]} ${match[1] === '1' ? 'gift' : 'gifts'} of the selected type within your budget. The other suggestions are also within your budget.`;
    }

    if (trimmed.startsWith('Bekijk ') && !trimmed.startsWith('Bekijk alle ')) {
      const rest = trimmed.slice(7);
      return dcLang === 'de' ? `Produkt ansehen: ${rest}` : `View ${rest}`;
    }

    return text;
  };

  const dcTranslateTree = (root) => {
    if (!dcDict || !root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);
    textNodes.forEach((node) => {
      if (dcSkipTags.has(node.parentElement?.tagName)) return;
      const next = dcTranslateDynamic(node.nodeValue || '');
      if (next !== node.nodeValue) node.nodeValue = next;
    });
    root.querySelectorAll?.('[aria-label],[aria-valuetext],[title],[placeholder]').forEach((el) => {
      ['aria-label', 'aria-valuetext', 'title', 'placeholder'].forEach((attr) => {
        const value = el.getAttribute(attr);
        if (!value) return;
        const next = dcTranslateDynamic(value);
        if (next !== value) el.setAttribute(attr, next);
      });
    });
  };

  const dcSetupI18n = (root) => {
    if (!dcDict || !(root instanceof HTMLElement)) return;
    const section = root.closest('.dc-gift-finder-section') || root;
    if (section.dataset.dcGiftFinderI18nReady === 'true') return;
    section.dataset.dcGiftFinderI18nReady = 'true';
    dcTranslateTree(section);
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') {
          if (mutation.target.parentElement) dcTranslateTree(mutation.target.parentElement);
          return;
        }
        if (mutation.type === 'attributes') {
          dcTranslateTree(mutation.target);
          return;
        }
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) dcTranslateTree(node);
          else if (node.nodeType === 3 && node.parentElement) dcTranslateTree(node.parentElement);
        });
      });
    }).observe(section, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-label', 'aria-valuetext', 'title', 'placeholder'] });
  };

  const recipientLabels = {
    him: dcTranslateDynamic('Voor hem'),
    her: dcTranslateDynamic('Voor haar'),
    together: dcTranslateDynamic('Voor samen'),
    business: dcTranslateDynamic('Zakelijk'),
    self: dcTranslateDynamic('Voor mezelf')
  };

  const typeLabels = {
    personalized: dcTranslateDynamic('Gepersonaliseerd'),
    utrecht: dcTranslateDynamic('Typisch Utrecht'),
    home: dcTranslateDynamic('Voor in huis'),
    jewelry: dcTranslateDynamic('Sieraad'),
    wood: dcTranslateDynamic('Houten cadeau'),
    small: dcTranslateDynamic('Klein cadeautje')
  };

  const budgetLabels = {
    upto15: dcLang === 'de' ? 'Bis €15' : (dcLang === 'en' ? 'Up to €15' : 'Tot €15'),
    '15to30': '€15 – €30',
    '30to60': '€30 – €60',
    '60plus': '€60+'
  };

  const progressTitles = [
    dcTranslateDynamic('Voor wie?'),
    dcTranslateDynamic('Type cadeau'),
    dcTranslateDynamic('Budget')
  ];
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const budgetMatches = (price, budget) => {
    if (budget === 'upto15') return price <= 1500;
    if (budget === '15to30') return price > 1500 && price <= 3000;
    if (budget === '30to60') return price > 3000 && price <= 6000;
    if (budget === '60plus') return price > 6000;
    return true;
  };

  const budgetDistance = (price, budget) => {
    if (budget === 'upto15') return Math.abs(price - 1100);
    if (budget === '15to30') return Math.abs(price - 2250);
    if (budget === '30to60') return Math.abs(price - 4500);
    if (budget === '60plus') return Math.abs(price - 8000);
    return 0;
  };

  const recipientBonus = (item, recipient) => {
    const categories = item.categories;
    const family = item.family;
    if (recipient === 'together') {
      let score = categories.has('home') ? 4 : 0;
      if (['boards', 'glass', 'decor', 'candle'].includes(family)) score += 2;
      return score;
    }
    if (recipient === 'business') {
      let score = item.personalized ? 4 : 0;
      if (categories.has('wood')) score += 2;
      if (['boards', 'glass', 'wallet'].includes(family)) score += 1;
      return score;
    }
    if (recipient === 'him' && ['opener', 'wallet', 'keychain', 'domtoren'].includes(family)) return 1;
    if (recipient === 'her' && ['jewelry', 'candle', 'decor'].includes(family)) return 1;
    return 0;
  };

  const loadCardImage = (card) => {
    const image = card.querySelector('img[data-dc-src]');
    if (!image || image.dataset.dcLoaded === 'true') return;
    const src = image.dataset.dcSrc;
    const srcset = image.dataset.dcSrcset;
    if (srcset) image.srcset = srcset;
    if (src) image.src = src;
    image.dataset.dcLoaded = 'true';
  };

  const parseProducts = (root) => [...root.querySelectorAll('[data-dc-product]')].map((card, index) => ({
    card,
    index,
    categories: new Set((card.dataset.categories || '').split(',').filter(Boolean)),
    family: card.dataset.family || 'utrecht',
    price: Number(card.dataset.price || 0),
    personalized: card.dataset.personalized === 'true'
  }));

  const chooseDiverse = (ranked, count = 4) => {
    const chosen = [];
    const chosenSet = new Set();
    const familyCounts = new Map();
    for (const maxPerFamily of [1, 2, 99]) {
      for (const item of ranked) {
        if (chosen.length >= count) break;
        if (chosenSet.has(item.index)) continue;
        const familyCount = familyCounts.get(item.family) || 0;
        if (familyCount >= maxPerFamily) continue;
        chosen.push(item);
        chosenSet.add(item.index);
        familyCounts.set(item.family, familyCount + 1);
      }
      if (chosen.length >= count) break;
    }
    return chosen;
  };

  const setupFinder = (root) => {
    if (!(root instanceof HTMLElement) || root.dataset.dcGiftFinderReady === 'true') return;
    dcSetupI18n(root);
    root.dataset.dcGiftFinderReady = 'true';

    const steps = [...root.querySelectorAll('[data-dc-step]')];
    const buttons = [...root.querySelectorAll('[data-dc-choice]')];
    const progress = root.querySelector('[data-dc-progress]');
    const progressBars = progress ? [...progress.querySelectorAll('span')] : [];
    const progressLabel = root.querySelector('[data-dc-progress-label]');
    const progressTitle = root.querySelector('[data-dc-progress-title]');
    const complete = root.querySelector('[data-dc-complete]');
    const resultWrap = root.querySelector('[data-dc-results]');
    const resultSummary = root.querySelector('[data-dc-result-summary]');
    const chips = root.querySelector('[data-dc-selection-chips]');
    const products = parseProducts(root);
    const state = { recipient: null, type: null, budget: null };
    let currentStep = 0;

    const typeButtons = buttons.filter((button) => button.dataset.key === 'type');
    const budgetButtons = buttons.filter((button) => button.dataset.key === 'budget');

    const updateTypeAvailability = () => {
      typeButtons.forEach((button) => {
        const hasMatches = products.some((item) => item.categories.has(button.dataset.value));
        button.hidden = !hasMatches;
        button.disabled = !hasMatches;
      });
    };

    const updateBudgetAvailability = () => {
      const typePool = products.filter((item) => item.categories.has(state.type));
      budgetButtons.forEach((button) => {
        const hasMatches = typePool.some((item) => budgetMatches(item.price, button.dataset.value));
        button.hidden = !hasMatches;
        button.disabled = !hasMatches;
        if (!hasMatches && state.budget === button.dataset.value) state.budget = null;
      });
    };

    const updateProgress = (index) => {
      currentStep = index;
      if (progress) progress.setAttribute('aria-valuenow', String(Math.min(index + 1, 3)));
      if (progressLabel) progressLabel.textContent = dcTranslateDynamic(`Stap ${Math.min(index + 1, 3)} van 3`);
      if (progressTitle) progressTitle.textContent = progressTitles[Math.min(index, 2)];
      progressBars.forEach((bar, barIndex) => {
        bar.classList.toggle('is-active', barIndex === Math.min(index, 2));
        bar.classList.toggle('is-complete', barIndex < Math.min(index, 3));
      });
    };

    const showStep = (index) => {
      steps.forEach((step, stepIndex) => {
        const active = stepIndex === index;
        step.hidden = !active;
        step.classList.toggle('is-active', active);
      });
      if (complete) complete.hidden = true;
      updateProgress(index);
      const heading = steps[index]?.querySelector('h3');
      if (heading && index > 0) heading.focus?.({ preventScroll: true });
    };

    const setPressed = (key, value) => {
      buttons.filter((button) => button.dataset.key === key).forEach((button) => {
        button.setAttribute('aria-pressed', button.dataset.value === value ? 'true' : 'false');
      });
    };

    const buildChips = () => {
      if (!chips) return;
      chips.replaceChildren();
      [recipientLabels[state.recipient], typeLabels[state.type], budgetLabels[state.budget]].filter(Boolean).forEach((label) => {
        const chip = document.createElement('span');
        chip.textContent = label;
        chips.appendChild(chip);
      });
    };

    const renderResults = () => {
      products.forEach((item) => {
        item.card.hidden = true;
        item.card.style.removeProperty('--dc-result-order');
      });
      const exactPool = products.filter((item) =>
        item.categories.has(state.type) && budgetMatches(item.price, state.budget)
      );
      const ranked = exactPool.map((item) => ({
        ...item,
        recipientScore: recipientBonus(item, state.recipient),
        distance: budgetDistance(item.price, state.budget)
      })).sort((a, b) =>
        b.recipientScore - a.recipientScore ||
        a.distance - b.distance ||
        a.price - b.price ||
        a.index - b.index
      );

      const chosen = chooseDiverse(ranked, Math.min(4, ranked.length));
      chosen.forEach((item, order) => {
        item.card.style.setProperty('--dc-result-order', order);
        item.card.hidden = false;
        loadCardImage(item.card);
      });

      if (resultSummary) {
        if (chosen.length === 0) {
          resultSummary.textContent = dcTranslateDynamic('Voor deze combinatie zijn er op dit moment geen cadeaus binnen jouw gekozen budget. Pas je type of budget aan, of bekijk alle cadeaus.');
        } else {
          resultSummary.textContent = dcTranslateDynamic(
            chosen.length === 1
              ? '1 cadeau past bij jouw gekozen type en budget.'
              : `${chosen.length} cadeaus passen bij jouw gekozen type en budget.`
          );
        }
      }

      buildChips();
      steps.forEach((step) => {
        step.hidden = true;
        step.classList.remove('is-active');
      });
      if (complete) complete.hidden = false;
      if (resultWrap) resultWrap.hidden = false;
      updateProgress(2);
      progressBars.forEach((bar) => {
        bar.classList.remove('is-active');
        bar.classList.add('is-complete');
      });
      window.setTimeout(() => {
        resultWrap?.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
      }, reduceMotion.matches ? 0 : 180);
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const key = button.dataset.key;
        const value = button.dataset.value;
        if (!key || !value || !(key in state)) return;
        state[key] = value;
        setPressed(key, value);
        if (key === 'recipient') {
          window.setTimeout(() => showStep(1), reduceMotion.matches ? 0 : 145);
        } else if (key === 'type') {
          state.budget = null;
          setPressed('budget', null);
          updateBudgetAvailability();
          window.setTimeout(() => showStep(2), reduceMotion.matches ? 0 : 145);
        } else if (key === 'budget') {
          window.setTimeout(renderResults, reduceMotion.matches ? 0 : 160);
        }
      });
    });

    root.querySelectorAll('[data-dc-back]').forEach((button) => {
      button.addEventListener('click', () => showStep(Math.max(0, currentStep - 1)));
    });

    root.querySelectorAll('[data-dc-reset]').forEach((button) => {
      button.addEventListener('click', () => {
        state.recipient = null;
        state.type = null;
        state.budget = null;
        buttons.forEach((choice) => choice.setAttribute('aria-pressed', 'false'));
        products.forEach((item) => {
          item.card.hidden = true;
          item.card.style.removeProperty('--dc-result-order');
        });
        if (resultWrap) resultWrap.hidden = true;
        if (chips) chips.replaceChildren();
        showStep(0);
        root.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
      });
    });

    updateTypeAvailability();
    showStep(0);
  };

  const setupAll = () => document.querySelectorAll('[data-dc-gift-finder]').forEach(setupFinder);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupAll, { once: true });
  } else {
    setupAll();
  }
  document.addEventListener('shopify:section:load', setupAll);
})();
